import { render } from "./tradeOptions.vue?vue&type=template&id=d04b43b2&ts=true"
import script from "./tradeOptions.vue?vue&type=script&lang=ts"
export * from "./tradeOptions.vue?vue&type=script&lang=ts"

import "./tradeOptions.vue?vue&type=style&index=0&id=d04b43b2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__